import { Box, Button, Grid, Skeleton } from "@mui/material";
import React from "react";

const AddBranchSkeleton = () => {
  return (
    <div>
      <Box
        width={"100%"}
        // height={"85vh"}
        border={"1.5px solid #DAE0E4"}
        borderRadius={"5px"}
      >
        <Button
          style={{
            color: "#1D4A87",
            fontSize: "18px",
            width: "fit-content",
            marginTop: "-23px",
            marginRight: "23px",
            background: "#fff",
          }}
        >
          افزودن اطلاعات شعبه
        </Button>

        {
          <Grid
            container
            columns={14}
            gap={1}
            justifyContent={{
              xs: "center",
              sm: "center",
              md: "center",
              lg: "space-between",
            }}
            alignItems={"center"}
            padding={"0 1rem"}
            minHeight={"100px"}
          >
            <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
              <Skeleton animation="wave" width={"100%"} height={60} />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
              <Skeleton animation="wave" width={"100%"} height={60} />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
              <Skeleton animation="wave" width={"100%"} height={60} />
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
              <Grid
                container
                justifyContent={"center"}
                alignItems={"center"}
                gap={1}
                marginBottom={"8px"}
              >
                <Grid item xs={5} width={"100%"}>
                  <Skeleton animation="wave" width={"100%"} height={60} />
                </Grid>
                <Grid item xs={5} width={"100%"}>
                  <Skeleton animation="wave" width={"100%"} height={60} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        }
      </Box>

      <Box
        sx={{ border: "1px solid #DAE0E4" }}
        borderRadius={".5rem"}
        marginBottom={".6rem"}
      >
        <Grid
          container
          flexDirection={"column"}
          padding={"1.7rem"}
          gap={"10px"}
        >
          <Grid item xs={12}>
            <Grid container justifyContent={"space-between"}>
              <Skeleton animation="wave" width={"100%"} height={200} />
            </Grid>
            <Grid container justifyContent={"space-between"}>
              <Skeleton animation="wave" width={"100%"} height={200} />
            </Grid>
            <Grid container justifyContent={"space-between"}>
              <Skeleton animation="wave" width={"100%"} height={200} />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default AddBranchSkeleton;
